var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 30,
    viewBox: "0 0 107 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4038_38257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2428 4.79845C29.4176 2.26361 32.6797 0.652344 36.3257 0.652344H44.4607V6.45234H36.3257C34.5027 6.45234 32.8716 7.25656 31.7843 8.52397L17.2179 25.5062C15.0432 28.0411 11.7839 29.6495 8.13505 29.6495H0V23.8523H8.13505C9.95802 23.8523 11.5862 23.0481 12.6765 21.7807L27.2428 4.79845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6135 0.652344H50.3887V29.6523H56.6135V0.652344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7599 4.79845L84.7724 10.6439L89.7848 4.79845C91.9596 2.26361 95.2217 0.652344 98.8677 0.652344H107V6.45234H98.8677C97.0447 6.45234 95.4136 7.25656 94.3262 8.52397L88.6393 15.1509L94.3262 21.7779C95.4136 23.0453 97.0418 23.8495 98.8677 23.8495H107V29.6495H98.8677C95.2217 29.6495 91.9596 28.0411 89.7848 25.5062L84.7724 19.6636L79.7599 25.5062C77.5851 28.0411 74.323 29.6495 70.677 29.6495H62.542V23.8523H70.677C72.5 23.8523 74.1282 23.0481 75.2156 21.7807L80.8996 15.1538L75.2156 8.52397C74.1282 7.25656 72.4971 6.45234 70.677 6.45234H62.542V0.652344H70.677C74.3201 0.652344 77.5851 2.26361 79.7599 4.79845Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4038_38257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 29,
    fill: "white",
    transform: "translate(0 0.652344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/six.0bab67cf87663deb102ca05b4c67aba4.svg";
export { ForwardRef as ReactComponent };